import useRealtimeDocument from 'hooks/use-realtime-document';

export declare interface IFortniteLeaderboardItem {
  eliminations: number;
  matches: number;
  players: IPlayer[];
  points: number;
  rank: number;
  royals: number;
  teamId: string;
}

export declare interface IPlayer {
  displayName: string;
  flag?: string;
}

export declare interface IFortniteLeaderboard {
  eventId: string;
  eventWindowId: string;
  items: IFortniteLeaderboardItem[];
}

const useFortniteLeaderboard = ({ eventId, eventWindowId }: {
  eventId: string, eventWindowId: string,
}): [IFortniteLeaderboardItem[], boolean] => {
  const [doc, docLoaded] = useRealtimeDocument<IFortniteLeaderboard>(
    'fortnite_leaderboard', `${eventId}-${eventWindowId}`,
  );

  // Integrated leaderboard
  if (docLoaded && doc && doc.items) {
    return [doc.items, docLoaded];
  }
  return [[], docLoaded];
};

export default useFortniteLeaderboard;
